export const SELECTIONBOX = 'selectionBox';
export const Highlighter = 'highlighter';
export const Marker = 'marker';

